import { sortBy } from "async";
import LabelProvider from "core/components/label/LabelProvider";

export default LabelProvider.create({

	PanelTitle: {
		k: "catalog.header.title",
		v: "Courses"
	},

	PanelDescription: {
		k: "catalog.header.desc",
		v: "List of courses"
	},

	NoResults: {
		k: "catalog.noResults",
		v: "No results. Please try again with different parameters."
	},

	NotFoundTitle: {
		k: "course.notfound.title",
		v: "Course Not Found"
	},

	NotFoundDescription: {
		k: "course.notfound.description",
		v: ""
	},

	NotFoundAction: {
		k: "course.notfound.action",
		v: "Back to Catalog"
	},

	/*NoResultsTitle: {
		k: "catalog.noResults.title",
		v: "No results"
	},

	NoResultsMore: {
		k: "catalog.noResults",
		v: "Please try again with different parameters"
	},*/


	subscriptionExpired: {
		k: "catalog.subscriptionExpired",
		v: " Subscription is Expired"
	},

	LaunchCourse: {
		k: "catalog.launchCourse",
		v: "Launch Course"
	},

	LaunchProgram: {
		k: "catalog.launchProgram",
		v: "Launch Program"
	},

	LaunchCourseItem: {
		k: "catalog.launchCourseItem",
		v: "Launch"
	},

	EnrollCourse: {
		k: 'catalog.enrollCourse',
		v: 'Enroll'
	},

	PreviewCourse: {
		k: 'catalog.previewCourse',
		v: 'Preview'
	},
    WaitingList: {
		k: 'catalog.waitingList',
		v: 'Waiting List'
	},

	SubscriptionExtend: {
		k: 'subscription.extend',
		v: 'Extend Subscription'
	},

	SubscriptionExtendBuy: {
		k: 'subscription.extendBuy',
		v: 'Extend Subscription'
	},

	SubscriptionAddCart: {
		k: 'subscription.extendBuy',
		v: 'Add to Cart'
	},

	ViewDetails: {
		k: "catalog.viewDetails",
		v: "View Details"
	},

	CoursePrice: {
		k: "catalog.course.price",
		v: "${title}",
		argNames: ["price", "title"]
	},
	
	CourseDueDate: {
		k: "catalog.course.dueDate",
		v: "Due Date ${date}",
		argNames: ["date"]
	},

	BuyCourse: {
		k: "catalog.buyCourse",
		v: "Add to Cart",
		argNames: ["price", "title"]
	},


	CourseBuy: { //added for new checkout feature
		k: "catalog.courseBuy",
		v: "Buy Course",
		argNames: ["price", "title"]
	},

	ResultMeta: {
		k: "catalog.resultMeta",
		v: "Showing ${start} - ${end} of ${total} results", // Showing 10 of 54 results
		argNames: ["start", "end", "total"]
	},

	ResultMetaLoading: {
		k: "catalog.resultMetaLoading",
		v: "Loading ${start} - ${end}", // Showing 10 of 54 results
		argNames: ["start", "end", "count"]
	},

	CompletionPercentage: {
		k: "catalog.completionPercentage",
		v: "${value} Completed", // 43% Completed
	},

	CompletedOn: {
		k: "completedOn",
		v: "Completed On ${date}",
		argNames: ["date"]
	},

	SortBy: {
		k: "catalog.sortBy",
		v: "Sort By"
	},

	AddToCalendar: {
		k: "course.addToCalendar",
		v: "Add to Calendar"
	},

	MoreInfo:{
		k:"course.moreInfo",
		v:"More Info",
	},

	Categories:  {
		k: "coruse.intelrco.categories",
		v: "Categories"
	},

	New: {
		k: "course.new",
		v: "New!"
	},

	Required: {
		k: "course.required",
		v: "Required"
	},

	DisplayDates: {
		k: "course.displayDates",
		v: "${start} -- ${end}",
		argNames: ["start", "end"]
	},

	CartSummary: {
		k: "cartSummary",
		v: "${itemsCount} Item(s) ${itemsCost}",
		argNames: ["itemsCount", "itemsCost"]
	},

	CartItemsSummary: {
		k: "cartItemsSummary",
		v: "${itemsCount} Item(s) ${itemsCost}",
		argNames: ["itemsCount", "itemsCost"]
	},

	CourseBookmark: {
		k: "course.addToBookmark",
		v: "${title}",
		argNames: ["title"]
	},

	Institution: {
		k: "catalog.institution",
		v: "Institution(s)"
	},

	ShowVariants: {
		k: "catalog.showVariants",
		v: "Show Variants Format",
		argNames: ["price", "title"]
	},

	NotStarted: {
		k: "catalog.notStarted",
		v: "Not Started"
	},

	Started: {
		k: "catalog.started",
		v: "Started"
	},

	Completed: {
		k: "catalog.completed",
		v: "Completed"
	}


});



// WEBPACK FOOTER //
// ./src/panels/catalog/Catalog.labels.tsx